export default {
    id_object: 'ID del objeto',
    uuid_intervener_tax_address: 'ID dirección interviniente',
    account_type: 'Tipo de cuenta',
    active: 'Activo',
    alias_account: 'Alias de la cuenta',
    alias: 'Alias de la cuenta',
    notes: 'Notas',
    annual_reporting: 'Indicador inf. anual',
    birthdate: 'Fecha nacimiento / constitución',
    block_xt_transfers: 'Bloqueo trasp. salida ext.',
    birth_date: 'Fecha nacimiento / constitución',
    is_transfers_blocked: 'Bloqueo trasp. salida ext.',
    blocking_date: 'Fecha bloqueo',
    brand_name: 'Razón social',
    cee_resident: 'Indicador comunitario',
    source: 'Canal',
    signature_type: 'Tipo de firma',
    closing_date: 'Fecha baja',
    cnae_code: 'CNAE Código',
    cnae_group: 'CNAE Grupo',
    confirm_ops: 'Ind. confirmación operaciones',
    linkedin: 'Linkedin',
    facebook: 'Facebook',
    twitter: 'Twitter',
    instagram: 'Instagram',
    created_on: 'Creado',
    // creation_date: 'Fecha creación',
    dealer: 'Distribuidor/Subdistribuidor',
    decease_date: 'Fecha fallecimiento',
    deathdate: 'Fecha fallecimiento',
    department: 'Departamento',
    description: 'Descripción',
    disability: 'Minusvalía',
    disability_percentage: 'Grado minusvalía',
    display_name: 'Nombre',
    email: 'Email',
    password: 'Contraseña',
    email_action: 'Tratamiento de Email',
    extlink_rd: 'Cód. Externo (RD)',
    intlink_rd: 'Cód. Interno (RD)',
    family_name: 'Apellidos',
    family_name_1: 'Primer apellido',
    family_name_2: 'Segundo apellido',
    finance_entity: 'Entidad financiera',
    first_subscription_date: 'Fecha 1ª aportación',
    fiscal_group: 'Grupo retención',
    name: 'Nombre',
    given_name: 'Nombre',
    lastname_1: 'Apellido 1',
    lastname_2: 'Apellido 2',
    ignore_fiscal_group: 'Ind. exclusión del grupo fiscal',
    intervener_type: 'Tipo de interviniente',
    key_account_arragement_type: 'Tipo cuenta',
    key_nationality_1: 'Nacionalidad 1',
    key_nationality_2: 'Nacionalidad 2',
    key_country_nationality1: 'Nacionalidad 1',
    key_country_nationality2: 'Nacionalidad 2',
    key_country_of_birth: 'País nacimiento / constitución',
    key_city_of_birth: 'Ciudad nacimiento',
    city_of_birth: 'Ciudad nacimiento',
    key_legal_person_type: 'Tipo Entidad (Jurídicas)',
    legal_type: 'Tipo Entidad (Jurídicas)',
    key_marital_status: 'Estado civil',
    marital_status: 'Estado civil',
    matrimonial_regime: 'Régimen matrimonial',
    key_name: 'Key',
    key_profession: 'Profesión',
    key_profession_area: 'Area profesional',
    lei_code: 'Código LEI',
    lei_expiration_date: 'Fecha caducidad LEI',
    minor: 'Indicador menor',
    opening_date: 'Fecha alta',
    patrimony: 'Patrimonio',
    permission_set: 'Set de permisos',
    photo: 'Imagen',
    postmail_action: 'Tratamiento de correspondencia',
    registration_date: 'Fecha registro',
    registration_name: 'Razón social',
    removed: 'Eliminado',
    removed_on: 'Fecha eliminado',
    safety_indicator: 'Indicador de seguridad',
    semestral_reporting: 'Indicador inf. semestral',
    gender: 'Sexo',
    spanish_resident: 'Indicador nacional o extranjero',
    telephone: 'Teléfono',
    total_users: 'Usuarios',
    trimestral_reporting: 'Indicador inf. trimestral',
    updated_on: 'Actualizado',
    username: 'Usuario',
    uuid: 'UUID',
    uuid_agent: 'Agente',
    uuid_dealer: 'Distribuidor',
    uuid_fiscal_address: 'Dirección fiscal',
    uuid_group: 'UUID de grupo',
    marital_regime: 'Regimen matrimonial',
    uuid_permission_set: 'UUID de permision set',
    uuid_postmail_address: 'Dirección postal',
    f_address_street_1: 'Dirección 1',
    f_address_street_2: 'Dirección 2',
    f_address_number: 'Número',
    f_address_floor: 'Piso',
    f_address_postal_code: 'Código postal',
    f_address_door: 'Puerta',
    f_address_stairs: 'Escalera',
    f_address_city: 'Población',
    f_address_state: 'Provincia',
    f_address_key_state: 'Código de provincia',
    f_address_key_country: 'País',
    is_deleted: 'Eliminado',
    deleted_on: 'Fecha eliminación',
    uuid_subdealer: 'Subdistribuidor',
    uuid_subsidiary: 'Sucursal',
    withholding_tax_exemption: 'Indicador exención retención',
    withholding_tax_group: 'Grupo retención',
    document_type: 'Tipo documento',
    is_withholding_tax_exempt: 'Indicador exención retención',
    withholding_group: 'Grupo retención',
    id_document_type: 'Tipo documento',
    document_number: 'Número de documento',
    expiration_date: 'Fecha expiración',
    document_expiration_date: 'Fecha expiración',
    is_document_permanent: 'Documento sin fecha expiración',
    valid: 'Válido',
    contact_medium: 'Método de contacto',
    fax_number: 'Número de fax',
    fax_country: 'País del fax',
    fax_prefix: 'Prefijo fax',
    mobile_prefix: 'Prefijo',
    mobile_country: 'País del móvil',
    key_mobile_phone_prefix: 'Prefijo móvil',
    mobile_phone: 'Teléfono móvil',
    key_home_phone_prefix: 'Prefijo casa',
    home_phone: 'Teléfono casa',
    key_work_phone_prefix: 'Prefijo trabajo',
    work_phone: 'Teléfono trabajo',
    key_other_phone_prefix: 'Prefijo otro',
    other_phone: 'Otro teléfono',
    registrales_1: 'Notario',
    registrales_2: 'Libro, Sección, Tomo, Folio, Hoja',
    registrales_3: 'Cod. DGS',
    registrales_4: 'Protocolo',
    registrales_5: 'Cod. CNMV',
    registrales_6: 'Registro mercantil',
    registrales_7: 'Cod. Bde',
    creation_date: 'Fecha alta',
    key_entity_type: 'Tipo entidad',
    foreign_indicator: 'Indicador nacional extranjero',
    validation_indicator: 'Estado validación',
    cnae_subgroup: 'CNAE Subgrupo',
    cee_indicator: 'Indicador comunitario',
    profession_area: 'Área profesional',
    proof_of_life_date: 'Fe de vida',
    proof_of_life_document: 'Documento Fe de vida',
    uuid_issue_type: 'Tipo incidencia',
    uuid_user_opened: 'Propietario',
    user_opened: 'Propietario',
    uuid_user_assigned: 'Identificador usuario asignado',
    user_assigned: 'Usuario asignado',
    uuid_group_assigned: 'Identificador grupo asignado',
    group: 'Grupo',
    key_status: 'Estado',
    expires_on: 'Expiración',
    blocking: 'Bloqueante',
    object: 'Objeto',
    asignee: 'Responsable',
    subject: 'Asunto',
    uuid_group_opened: 'Grupo abierto',
    key_issue_source: 'Fuente',
    giin_code: 'Código GIIN',
    street: 'Domicilio',
    street_1: 'Domicilio 1',
    street_2: 'Información adicional',
    floor: 'Planta',
    town: 'Localidad',
    door: 'Puerta',
    stairs: 'Escalera',
    city: 'Localidad',
    number: 'Número',
    state: 'Provincia/Región',
    key_state: 'Código de provincia/región',
    postal_code: 'Código postal',
    country: 'País',
    accounts: 'Cuentas',
    interveners: 'Intervinientes',
    profession: 'Profesión',
    front_document: 'Imagen anverso documento',
    back_document: 'Imagen reverso documento',
    key_issue_type: 'Tipo incidencia',
    notary: 'Notario',
    protocol: 'Protocolo',
    commercial_register: 'Registro Mercantil',
    mailing_type: 'Método de contacto',
    book: 'Libro',
    section: 'Sección',
    volume: 'Tomo',
    sheet: 'Hoja',
    registration_page: 'Folio',
    dgs_code: 'Código DGS',
    bgs_code: 'Código BGS',
    cnmv_code: 'Código CNMV',
    bde_code: 'Código BDE',
    indicator_fatca: 'Indicador FATCA',
    country_fatca: 'País FATCA',
    tin_code: 'Identificación fiscal',
    tin_type: 'Tipo TIN',
    fatca_status: 'Estatus FATCA',
    swift_code: 'Código SWIFT',
    bic_code: 'Código BIC',
    swift_or_bic_code: 'Código SWIFT o BIC',
    naisc_code: 'Código NAISC',
    ffi_eni_code: 'Código FFI ENI',
    qi_eni_code: 'Código QI ENI',
    ffi_group: 'Grupo FFI',
    transfer_country: 'País destino transferencia',
    transfer_reference: 'Referencia de transferencia',
    ccc_legal_guardian: 'Guardian legal de cuenta',
    ccc_direct_billing: 'Cuenta de facturación directa',
    rejection_cause: 'Causa de rechazo',
    apply_reduction_coefficient: 'Reducción de coefficiente',
    account: 'Cuenta',
    account_number: 'Número cuenta',
    account_holder: 'Titular cuenta',
    ACCOUNT_HOLDER: 'Titular cuenta',
    nullified: 'Anulada',
    us_name: 'us_name',
    fiscal_residence: 'País residencia fiscal',
    nationality_country: 'País nacionalidad fiscal',
    category: 'Categoría',
    subcategory: 'Subcategoría',
    group_assigned: 'Grupo asignado',
    validate_date: 'Fecha validez',
    country_residence: 'País residencia',
    type_name: 'Tipo nombre',
    text_address: 'Dirección',
    text_town: 'Localidad',
    direction_type: 'Tipo dirección',
    tin_country: 'País emisor TIN',
    uuid_intervener: 'UUID Interviniente',
    uuid_account: 'UUID Cuenta',
    participation_type: 'Tipo participación',
    orden: 'Orden',
    holding_percentage: '% participación',
    dato1: 'Dato1',
    dato2: 'Dato2',
    dato3: 'Dato3',
    dato4: 'Dato4',
    dato5: 'Dato5',
    dato6: 'Dato6',
    periodic_operation: 'Operación periódica',
    participations: 'Participaciones',
    operation_date: 'Fecha operación',
    uuid_operation: 'UUID operación',
    holder_name: 'Nombre y apellidos del primer titular',
    cash: 'Importe',
    net_value: 'Liquidativo',
    status: 'Estado',
    operation_type: 'Tipo operación',
    operation_sub_type: 'Subtipo operación',
    refund: 'Reembolso',
    totally_refunded: 'Reembolso total',
    iban_code: 'Código IBAN',
    uuid_product: 'UUID de Producto',
    added_operation: 'Operación añadida',
    value_date: 'Fecha solicitud',
    currency_cash: 'Currency cash',
    currency_comision: 'Currency comision',
    currency_com_comision: 'Currency com comision',
    currency_expenses: 'Currency expenses',
    currency_net: 'Currency net',
    currency_fiscal_import: 'Currency fiscal import',
    currency_change: 'Currency change',
    comision: 'Comision',
    commission: 'Comision',
    com_comision: 'Com comision',
    expenses: 'Expenses',
    fiscal_import: 'Importe fiscal',
    currency_worth: 'Currency worth',
    net: 'Net',
    worth: 'Valor',
    real_worth: 'Valor real',
    withholding: 'Retenciones',
    currency_withholding: 'Currency WH',
    fund_participations: 'Fund participation',
    net_value_date: 'Fecha valor liquidativo',
    settlement_date: 'Fecha settlement',
    withholding_percentage: 'Porcentaje',
    fiscal_date: 'Fecha fiscal',
    due_date: 'Fecha límite',
    fiscal_treatment: 'Trato fiscal',
    general_worth: 'Valor general',
    special_worth: 'Valor especial',
    itemization_type: 'Tipo itemización',
    balance_treatment: 'Trato de balance',
    itemization_date: 'Fecha itemización',
    identity_document: 'Documento de identidad',
    document_id: 'Documento de identidad',
    identity_document_type: 'Tipo documento identidad',
    // legal_entity_type: 'Entidad legal',
    entity_type: 'Tipo entidad',
    is_financial_entity: 'Entidad financiera',
    phone1_country: 'País teléfono 1',
    phone2_country: 'País teléfono 2',
    phone3_country: 'País teléfono 3',
    mobile_number: 'Número móvil',
    product_name: 'Nombre de producto',
    net_asset_value: 'Valor liquidativo',
    date_of_asset_value: 'Fecha valor liquidativo',
    fiscal_address: 'Dirección fiscal',
    identity_document_expiration_date: 'Expiración documento identidad',
    resolved_on: 'Fecha resolución',
    uuid_distributor: 'UUID Distribuidor',
    uuid_subdistributor: 'UUID Subdistribuidor',
    document_subcategory: 'Subcategoría',
    distributor: 'Distribuidor',
    distributors: 'Distribuidores',
    subdistributor: 'Subdistribuidor',
    total_net_assets_value: 'Patrimonio total',
    shares: 'Participaciones',
    net_amount: 'Importe neto',
    gross_amount: 'Importe bruto',
    is_periodic: 'Operación periódica',
    is_periodic_request: 'Operación periódica desencadenante',
    per_period: 'Periodicidad',
    per_end_date: 'Fecha fin operación',
    per_increase_type: 'Tipo revalorización',
    per_increase: 'Revalorización',
    per_increase_period: 'Periodicidad de revalorización',
    uuid_per_operation_periodic_request: 'UUID operación desencadenante',
    key_product: 'Fondo',
    name_product: 'Fondo',
    parent_product_name: 'Fondo padre',
    key_operation_type: 'Tipo operación',
    nav: 'Valor liquidativo',
    nav_date: 'Fecha VL',
    amount_shares_indicator: 'Indicador tipo cantidad',
    is_total_redemption: 'Reembolso total',
    is_total_transfer: 'Traspaso total',
    pp_redemption_cause: 'Causa rescate',
    pp_redemption_rendering_variation_type: 'Tipo variación',
    pp_redemption_rendering_variation: 'Cantidad variación',
    pp_redemption_rendering_variation_date: 'Fecha adelanto',
    pp_redemption_collection_method: 'Forma cobro',
    pp_redemption_defer: 'Aplazamiento',
    pp_source_situation: 'Situación origen',
    pp_compartment: 'Compartimentos',
    pp_redemption_entitlement_date: 'Fecha percepcion',
    pp_plan_type: 'Tipo plan',
    pp_xt_dgs_code: 'Código DGS',
    pp_xt_dgs_gestor_code: 'Entidad origen (código gestora)',
    pp_rights_type: 'Tipo derechos',
    transfer_nav_on_month_end: 'Valor de traspaso al cierre del mes',
    pp_redemption_mixed_amount: 'Cantidad periódica (renta mixta)',
    request_date: 'Fecha solicitud',
    pay_method: 'Tipo pago',
    is_request: 'Solicitud',
    source_system: 'Sistema fuente',
    intervener_issues_count: 'Casos abiertos',
    uuid_request: 'UUID operación de solicitud',
    account_id_object: 'ID Cuenta',
    user_owner: 'Usuario propietario',
    xt_isin_code: 'Código isin',
    xt_account_origin: 'Cuenta de origen (traspaso)',
    has_data_protection_analyze_operations: 'Acepta analizar operaciones',
    has_data_protection_send_communications: 'Acepta enviar comunicaciones',
    has_data_protection_send_info: 'Acepta enviar información',
    has_data_protection_value_school: 'Acepta value school',
    has_done_private_area_first_login: 'Primer login',
    can_be_validated: 'Puede ser validado',
    operations: 'Operaciones',
    object_type: 'Tipo de objecto',
    account_issues_count: 'Casos abiertos',
    class: 'Clase',
    has_draft_data: 'Datos pendientes de bastantear',
    request_timestamp: 'Fecha solicitud'
    // custom_legal_entity_type: 'Indique la entidad legal'
};
